import LEVELS from 'constants/Levels';
import PageLayout from '@/components/PageLayout';
import Page from '@/components/Page';
import { entryPoint } from 'react_rails/entryPoint';
import { SchoolsTeamsQuery, SchoolsTeamsQueryVariables } from 'queries';
import HeadlinesModule from '@/components/modules/HeadlinesModule';
import ContentSection, { ContentSectionFlushContent } from '@/components/ContentSection';
import PageHeader from '@/components/PageHeader';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';
import Table, { TableCell, TableHeaderCell, TableLinkRow } from '@/components/Table';
import TextLink, { TextColorVariant, TextLinkSize } from '@/components/TextLink';
import GenderSportIcon from '@/components/GenderSportIcon';
import styles from './styles/Teams.module.scss';
import SchoolSubNav from '@/components/subNavs/SchoolSubNav';
import filterArticles from 'helpers/filterArticles';
import { useApplicationContainer } from 'containers/ApplicationContainer';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import useScreenSize from 'hooks/useScreenSize';
import StnVideoAd from '@/components/ads/StnVideoAd';
import OutbrainAd from '@/components/ads/OutbrainAd';

export default entryPoint(function Teams({
  query: { school },
  variables
}: {
  query: SchoolsTeamsQuery;
  variables: SchoolsTeamsQueryVariables;
}) {
  const level = LEVELS.find(({ key }) => key === variables.level)!;
  const articles = filterArticles(school.articles.nodes);
  const [, { updateCurrentQueryStringParams }] = useApplicationContainer();
  const { isSmallScreen } = useScreenSize();

  return (
    <Page subNav={<SchoolSubNav school={school} />}>
      <PageLayout
        sidebar={
          <>
            <MinuteMediaAd placement="SIDEBAR" />
            {articles.length > 0 && <HeadlinesModule articles={articles} title="Related News" href={school.webNewsPath} />}
            <MinuteMediaAd placement="SIDEBAR_2" />
          </>
        }
      >
        {!isSmallScreen && (
          <div style={{ width: '100%' }}>
            <StnVideoAd placement="INLINE" />
          </div>
        )}
        <ContentSection>
          <PageHeader right={<ApplicationShareButton />}>
            {school.name} {level.name} Teams
          </PageHeader>
          <ContentSectionFlushContent>
            <Table
              className={styles.Table}
              header={
                <>
                  <TableHeaderCell>Sports</TableHeaderCell>
                  <TableHeaderCell align="right">OVR</TableHeaderCell>
                  <TableHeaderCell align="right">PCT</TableHeaderCell>
                  <TableHeaderCell align="right">League</TableHeaderCell>
                </>
              }
            >
              {school.teams.nodes
                .sort((a, b) => a.genderSport.sport.name.localeCompare(b.genderSport.sport.name))
                .map(team => (
                  <TableLinkRow key={team.id} href={team.webPath}>
                    <TableCell>
                      <TextLink href={team.webPath} size={TextLinkSize.SMALL} color={TextColorVariant.BLACK}>
                        <GenderSportIcon genderSport={team.genderSport} />
                        {team.genderSport.name}
                      </TextLink>
                    </TableCell>
                    <TableCell align="right">{team.standing.overallRecord || '-'}</TableCell>
                    <TableCell align="right">{team.standing.overallWinPercentage || '-'}</TableCell>
                    <TableCell align="right">{team.league && <TextLink href={team.league.webPath}>{team.league.name}</TextLink>}</TableCell>
                  </TableLinkRow>
                ))}
            </Table>
          </ContentSectionFlushContent>
        </ContentSection>
        <div style={{ width: '100%', paddingTop: '20px' }}>
          <MinuteMediaAd placement="IN_FEED" />
        </div>
        <OutbrainAd />
      </PageLayout>
    </Page>
  );
});
